import { UserRole } from '@/apolloClient.types';
import { useUser } from '@/contexts/UserSession';

const useContentManagementAbilities = () => {
    const user = useUser(true);
    const role = user.__typename === 'TenantUser' ? user.role : null;
    const company = user.__typename === 'TenantUser' ? user.company : null;

    const canViewModuleDefinitions = () => {
        return !!company && [UserRole.CompanyAdmin, UserRole.CourseAdmin, UserRole.Trainer].includes(role!);
    };

    const canViewAssessments = () => {
        return !!company && [UserRole.CompanyAdmin, UserRole.CourseAdmin, UserRole.Trainer].includes(role!);
    };

    const canManageAssessments = () => {
        // CompanyAdmin can create assessments
        return !!company && role === UserRole.CompanyAdmin;
    };

    const canViewTraining = () => {
        return !!company;
    };

    const canManageTraining = () => {
        // CompanyAdmin can create training materials
        return !!company && role === UserRole.CompanyAdmin;
    };

    const displayContentManagementMenuItem = () => {
        return (
            [UserRole.CompanyAdmin, UserRole.CourseAdmin, UserRole.Trainer].includes(role!) &&
            (canViewModuleDefinitions() || canViewAssessments() || canViewTraining())
        );
    };

    const canViewTraineeAssessments = () => {
        return !!company && [UserRole.Trainee, UserRole.Trainer].includes(role!);
    };

    const displayTraineeContentMenuItem = () => {
        return canViewTraineeAssessments();
    };

    return {
        canViewModuleDefinitions,
        canViewAssessments,
        canManageAssessments,
        canViewTraining,
        canManageTraining,
        displayContentManagementMenuItem,
        canViewTraineeAssessments,
        displayTraineeContentMenuItem,
    };
};

export type ContentManagementAbilities = ReturnType<typeof useContentManagementAbilities>;
export default useContentManagementAbilities;
